import React, { useContext, useState } from 'react';
import DataTable from '@preflighttech/preflight-tables';
import { Text, View, Pressable } from 'react-native';
import { FEES_WITH_COUNT, HIDE_FEE } from './queries';
import { useMutation } from '@apollo/client';
// import SubNav from './SubNav';
import SubNav from '../../elements/SubNav';
import { Link } from 'app/src/utils/routing';
import Filter from 'app/src/elements/Filter';
import { ResetSettings } from 'app/src/elements/Pagination/ResetSettings';
import { dateShort } from 'app/src/utils/timeFormatter';
import {
   MainContainer,
   ContentContainer,
   TableContainer,
   PageTitle,
   LinkContainer,
   TableNavbarContainer,
   LinkSpace,
   SubNavContainer
} from 'app/src/elements';
import moment from 'moment';
import { formatAssetNameForSelect } from '../../utils/formatAssetName';
import currencyFormatter from '../../utils/currencyFormatter';
import AuthContext from 'app/src/contexts/AuthContext';
import {
  downloadReport,
  DownloadButton
} from 'app/src/elements/ReportDownload';
import { createReport } from '../../elements/ReportCreate';
import { elRed } from '../../styles/colors';

const inputStyle = {
  marginBottom: '10px'
}

const FeeTable = (props) => {
  const { asset, fromSalesProcess, refetchAsset } = props;
  const [refetch, setRefetch] = useState();
  const [clickedFee, setClickedFee] = useState();
  const [showAddFeeModal, setShowAddFeeModal] = useState(false);
  const [showEditFeeModal, setShowEditFeeModal] = useState(false);
  const [filterOptions, setFilterOptions] = useState();
  const [filters, setFilters] = useState({});
  const [settings, setSettings] = useState({});
  const { hasPolicy, credentials } = useContext(AuthContext);
  const [pdfFeeIds, setPdfFeeIds] = useState([]);
  const [showReportCreated, setShowReportCreated] = useState(false);

  const queryVariables = {
    assetId: asset?.id,
    filterColumns: [],
    filterNames: [],
    scopes: [],
  };
  
  const setFilter = (key, value) => {
    const currentFilters = {...filters};
    currentFilters[key] = value;
    setFilters(currentFilters);
  }

  const handleChange = (value) => {
    let newPdfFeeIds = [];
    if(!pdfFeeIds.includes(value)) {
      newPdfFeeIds = [...pdfFeeIds, value];
    }else {
      newPdfFeeIds = pdfFeeIds.filter(id => id !== value)
    }

    setPdfFeeIds(newPdfFeeIds);
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (value) {
      queryVariables.filterColumns.push(key);
      queryVariables.filterNames.push(value);
    }
  });

  const handleCreate = () => {
    createReport({
      credentials: credentials,
      params: { 'assetId': asset.id, 'feeIds': JSON.stringify(pdfFeeIds) },
      onCompleted: () => {
        setShowReportCreated(true);
        if (refetchAsset) { refetchAsset(); }
      }
    });
  };

  const columns = 
    [
      {
        key: 'createdOn',
        label: 'Date Created'
      },
      {
        key: 'type',
        label: 'Type',
        content: (entry) => {
          return entry.entry.type
        }
      },
      {
        key: 'buyerFee',
        label: 'Buyer Fee?',
        content: (entry) => {
          return entry.entry.buyerFee ? 'Yes' : 'No'
        }
      },
      {
        key: 'amount',
        label: 'Amount',
        content: (entry) => {
          return currencyFormatter(entry.entry.amount);
        }
      },
      {
        key: 'description',
        label: 'Description',
        content: (entry) => {
          return entry.entry.description
        }
      },
      {
        key: 'createdByName',
        label: 'Added By'
      },
      {
        key: 'asset',
        label: 'Asset',
        content: ({ entry }) => (
          <>
              <a
                href={`/sellers/${entry.asset.seller.id}/assets/${entry.asset.id}`}
              >
                {entry.asset.lastSix} ({entry.asset.listings})
              </a>
          </>
        )
      },
      {
        key: 'saleAsset',
        label: 'Sale',
        content: ({ entry }) => (
          <>
            {entry.saleAsset?.sale?.saleOn}
          </>
        )
      },
      {
        key: 'feeEstimate',
        label: 'From Estimate?',
        content: (entry) => {
          if(entry.entry.feeEstimate) {
            return (
              <View>
                <Text>
                  {`${entry.value.acceptedByString} accepted by ${entry.entry.acceptMethod}`}
                </Text>
              </View>
            )
          }
        }
      },
    ] 

  const buttons = (
    <View style={{display: 'flex', flexDirection: 'row'}}>
      <Filter
        clearFilters={() => {
          setFilters({})
          setShowModal(false)
        }}
        filters={filters}
        setFilters={setFilters}
      >
      </Filter>
      <ResetSettings />
    </View>
  );

  return (
    <MainContainer>
      <ContentContainer>
        <TableContainer>
          <DataTable.Simple
            data={props.fees}
            columns={columns}
          />
        </TableContainer>
      </ContentContainer>
    </MainContainer>
  )
}

export default FeeTable;
